export const RatingIdiomaEnum = new Map([
	[0, 'NEN'],
	[1, 'BAS'],
	[2, 'INT'],
	[3, 'AVA']
]);
